import { ComponentProps, ReactNode } from 'react';
import clsx from 'clsx';

import styles from './CtaCard.module.css';

interface Props extends Omit<ComponentProps<'div'>, 'title'> {
  title?: ReactNode;
  description?: ReactNode;
  footer?: ReactNode;
  icon?: ReactNode;
}

export default function CtaCard({ title, description, footer, icon, className }: Props) {
  return (
    <div className={clsx(styles.card, className)}>
      <div className={styles.content}>
        <div className={styles.icon}>{icon}</div>
        {title && <h3 className={styles.title}>{title}</h3>}
        <p>{description}</p>
      </div>
      {footer && <div className={styles.footer}>{footer}</div>}
    </div>
  );
}
